import React from 'react'
// import Notes from './Assignment-2/Notes'
import Converter from './3.forms and hooks/Assignment-2(Crypto Converter)/Converter'
function App() {

  return (
    <div>
      {/* <Notes /> */}
      <Converter />
    </div>
  )
}

export default App